import { motion } from 'motion/react'
import { mq, sizes } from 'src/theme'
import styled from 'styled-components'

export const KeyFigure = styled.span`
  align-items: flex-end;
  align-self: flex-start;
`

export const Value = styled(motion.span)<{
  $mobile?: boolean
  $length?: number
}>`
  display: inline-block;
  white-space: nowrap;
  ${({ $mobile }) => {
    const _mq = $mobile ? mq(sizes.desktop) : mq(null, sizes.desktop)
    return `@media ${_mq} { display: none; }`
  }}
  ${({ $length }) => $length && `min-width: ${$length}ch;`}
`

export const Unit = styled.sup`
  font-size: 0.8em;
`
